import { Expose, Transform, Type } from "class-transformer";
import { OutsourcingDto } from "@/core/features/projects/embedded/outsourcing.dto";
import { toCents } from "@/utils/numberUtils";

export class CreateProjectDto {
  @Expose()
  description: string;

  @Expose()
  dossierId: string;

  @Expose()
  interventionId: string;

  @Expose()
  operativeUnitId: string;

  @Expose()
  workplaceId: string;

  @Expose()
  scope?: string;

  @Expose()
  plannerId?: string;

  @Expose()
  startDate?: Date;

  @Expose()
  endDate?: Date;

  @Expose()
  isUrgent?: boolean;

  @Expose()
  outsourcing?: OutsourcingDto;

  @Expose()
  modelId?: string;

  @Expose()
  elementId?: string;

  @Expose()
  projectPhaseId: string;

  @Expose()
  isPlannable: boolean;

  @Expose()
  hasPoints: boolean;

  @Expose()
  hasReport: boolean;

  @Expose()
  hasQuickWorksheet: boolean;

  @Expose()
  isSelfValidating: boolean;

  @Expose()
  canHaveOnCalls: boolean;

  @Expose()
  hasMandatoryVehicle: boolean;

  @Expose()
  hasAbroadWork: boolean;

  @Expose()
  @Transform(({ value }) => toCents(Number(value ?? 0)))
  abroadWorkTeamLeaderBonus?: number;

  @Expose()
  @Transform(({ value }) => toCents(Number(value ?? 0)))
  abroadWorkGeneralBonus?: number;

  @Expose()
  requiresExtraDocumentation: boolean;

  @Expose()
  @Type(() => Number)
  year?: number;
}
